
export class TranslationCategory {
    public TranslationCategoryId:number;

    public Name:string;

    public Description:string;

    public IsPage:boolean;

    public SortOrder:number;

    public IsDeleted:boolean;

    constructor(TranslationCategoryId:number = 0, Name:string = ""){
        this.TranslationCategoryId = TranslationCategoryId;
        this.Name = Name;
    }

    public static readonly NONE:number = 0;
    public static readonly COMMON:number = 1;
    public static readonly GOAL:number = 2;
    public static readonly GOAL_CATEGORY:number = 3;
    public static readonly PROJECT_PARTNER:number = 4;
    public static readonly PROJECT_CATEGORY:number = 5;
    public static readonly DASHBOARD_PAGE:number = 6;
    public static readonly CLUB_GOALS_PAGE:number = 7;
    public static readonly SUMMARY_VIEW_PAGE:number = 8;
    public static readonly SERVICE_ACTIVITIES_PAGE:number = 9;
    public static readonly TRENDS_PAGE:number = 10;
    public static readonly RESOURCES_PAGE:number = 11;
    public static readonly REPORTS_PAGE:number = 12;
    public static readonly CLUB_RATINGS_PAGE:number = 13;
    public static readonly RESOURCE:number = 14;
    public static readonly RESOURCE_CATEGORY:number = 15;
    public static readonly RESOURCE_URL:number = 16;
    public static readonly SERVICE_PROJECT_DETAILS_PAGE:number = 17;
    public static readonly CLUB_COMMENTS_PAGE:number = 18;
    public static readonly ORG_NAV:number = 19;
    public static readonly REPORT:number = 20;
    public static readonly REPORT_CATEGORY:number = 21;
    public static readonly REPORT_SUB_CATEGORY:number = 22;
    public static readonly GOAL_POPUP:number = 23;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/translation-category.ts